module.exports = __webpack_public_path__ + "static/media/workingmemory-words-introno.aa8e8865.mp3";